import {
    type RejectProfileUpdateRequestResponseType,
    type RejectProfileUpdateRequestRequestType
} from "./type";
import {
    request
} from "../request";

const rejectProfileUpdateRequest = async (
    params: RejectProfileUpdateRequestRequestType
): Promise<RejectProfileUpdateRequestResponseType> => {
    return await request<RejectProfileUpdateRequestResponseType>(
        "/request/rejectProfileUpdateRequest",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};
export default rejectProfileUpdateRequest;
